import { normalize, schema } from 'normalizr';
import { EventVideoViewModel, UploadedVideoViewModel } from 'stageclip-common';

import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';
import * as EventNormalizers from './eventNormalizers';

const { Entity } = schema;

export interface NormalizedEventVideos extends EventNormalizers.NormalizedEvents {
  eventVideos: ById<EventVideoViewModel>;
}

export const eventVideosSchema = new Entity('eventVideos', {
  event: EventNormalizers.eventSchema,
});

export function normalizeEventVideosArray(
  data: EventVideoViewModel[],
): EntityNormalizers.NormalizedEntityArray<NormalizedEventVideos> {
  return normalize(data, new schema.Array(eventVideosSchema));
}

export function normalizeEventVideo(
  data: EventVideoViewModel,
): EntityNormalizers.NormalizedSingleEntity<NormalizedEventVideos> {
  return normalize(data, eventVideosSchema);
}

export function normalizeUploadedVideosArray(
  data: UploadedVideoViewModel[],
): EntityNormalizers.NormalizedEntityArray<UploadedVideoViewModel[]> {
  return {
    entities: data,
    result: [],
  };
}
